import {TCurrency} from '@edna/utils';

import {TItemId} from 'src/constants';

enum EInvoiceType {
  DEFAULT = 'DEFAULT',
}

enum EInvoiceStatus {
  NEW = 'NEW',
  PENDING = 'PENDING',
  AUTHORISED = 'AUTHORISED',
  CAPTURE = 'CAPTURE',
  CAPTURED = 'CAPTURED',
  FAILED = 'FAILED',
  PAID = 'PAID',
  ERROR = 'ERROR',
  CANCELLED = 'CANCELLED',
}

enum EInvoiceKind {
  DUMMY = 'DUMMY',
  STRIPE = 'STRIPE',
}

type TInvoice = {
  id: TItemId;
  tenantId: 0;
  invoiceKind: EInvoiceKind;
  paymentUrl: string;
  status: EInvoiceStatus;
  statusUpdatedAt: string;
  createdAt: string;
  updatedAt: string;
  parameters: {
    type: EInvoiceType;
    currency: TCurrency;
    amount: number;
    comment: string;
  };
  error: string;
};

export {EInvoiceKind, EInvoiceType};
export type {TInvoice};
